import { Box, Typography } from "@mui/material";

const GridField = ({ label, value, ample = false }) => {
    if (ample) {
        return (
            <Box
                sx={{
                    gridColumn: "1 / -1",
                    py: 1.25,
                    borderBottom: "0.5px solid",
                    borderColor: "divider",
                }}
            >
                <Typography
                    sx={{ fontSize: 13, color: "text.secondary", mb: 0.5 }}
                >
                    {label}
                </Typography>
                <Typography
                    sx={{
                        fontSize: 13,
                        fontWeight: 500,
                        wordBreak: "break-all",
                    }}
                >
                    {value ?? "—"}
                </Typography>
            </Box>
        );
    }

    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "space-between",
                gap: 2,
                py: 1.25,
                borderBottom: "0.5px solid",
                borderColor: "divider",
            }}
        >
            <Typography sx={{ fontSize: 13, color: "text.secondary" }}>
                {label}
            </Typography>
            <Typography
                sx={{ fontSize: 13, fontWeight: 500, textAlign: "right" }}
            >
                {value ?? "—"}
            </Typography>
        </Box>
    );
};

export const FieldGrid = ({ fields }) => {
    const fieldsCurts = fields.filter((field) => !field.ample);
    const fieldsLlargs = fields.filter((field) => field.ample);

    return (
        <Box
            sx={{
                display: "grid",
                gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                columnGap: 3,
            }}
        >
            {fieldsCurts.map((f) => (
                <GridField key={f.key} label={f.key} value={f.value} />
            ))}
            {fieldsLlargs.map((f) => (
                <GridField key={f.key} label={f.key} value={f.value} ample />
            ))}
            {/* Els dos .map són separats perquè tots els camps llargs quedin junts
                al final (millor visualment que intercalats). Si prefereixes
                mantenir l'ordre original de la llista, es pot fer amb un sol
                .map i gridColumn condicional. 
                
                {fields.map((f) => (
                    <GridField key={f.key} label={f.key} value={f.value} ample={f.ample} />
                ))}
            */}
        </Box>
    );
};
